/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown>, title: NonNullable<unknown> }} Tr_Title_OriginalInputs */

const en_tr_title_original = /** @type {(inputs: Tr_Title_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original (${i?.language}): ${i?.title}`)
};

const de_tr_title_original = /** @type {(inputs: Tr_Title_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original (${i?.language}): ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Original ({language}): {title}" |
*
* @param {Tr_Title_OriginalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tr_title_original = /** @type {((inputs: Tr_Title_OriginalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tr_Title_OriginalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tr_title_original(inputs)
	return en_tr_title_original(inputs)
});